import styled from "@emotion/styled";
import { Stack, Typography } from "@mui/material";
import logoDarkTheme from "Assets/Images/Logos/logo_nsure_dt.png";
import logoLightTheme from "Assets/Images/Logos/logo_nsure_lt.png";

const LogoImage = styled.img`
	-webkit-user-drag: none;
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
`;

export const Logo = ({ isDarkLogo = false }) => {
	const source = isDarkLogo ? logoLightTheme : logoDarkTheme;
	const subtitle = (import.meta.env.VITE_NAME as string)?.toUpperCase() ?? null;
	let subtitleComponent = <></>;
	if (!!subtitle) {
		subtitleComponent = (
			<Typography
				variant="h1"
				noWrap
				component="div"
				color={subtitle === "PROD" ? "#ff2100" : isDarkLogo ? "black" : "white"}
				paddingLeft="6px"
				sx={{ userSelect: "none" }}
			>
				{subtitle}
			</Typography>
		);
	}
	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="center"
			width="100%"
		>
			<LogoImage src={source} alt="nsure" />
			{subtitleComponent}
		</Stack>
	);
};
